import { render } from "./OrganigramaComponent.vue?vue&type=template&id=67c85728"
import script from "./OrganigramaComponent.vue?vue&type=script&lang=js"
export * from "./OrganigramaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__